module.exports = "https://cdn.ticketswap.com/_next/static/images/mobile-screen-bigger-dark-cf6b8c453a4157c91a12f39aa86d953e.jpeg";